// Builds an ApiClient bound to the current Clerk session.
// Components call hooks from `src/client/data/*` which call into this.

import { useAuth } from "@clerk/clerk-react";
import { useMemo } from "react";
import { createApiClient, type ApiClient } from "../api";

export function useApi(): ApiClient {
  const { getToken } = useAuth();
  return useMemo(
    () =>
      createApiClient({
        getToken: () => getToken(),
      }),
    [getToken],
  );
}
